import { t } from 'i18next'
import * as Yup from 'yup'
import { FormField } from 'src/enums/Form'
import {
  Comunidad,
  Orden,
  OrganoJudicial,
  PartidoJudicial,
  Provincia
} from 'src/interfaces/Catalog'

export type OrganoDestinoFormValues = {
  [FormField.COMUNIDAD_AUTONOMA]: Comunidad | null
  [FormField.PROVINCIA]: Provincia | null
  [FormField.ORGANO_DESTINO_PARTIDO_JUDICIAL]: PartidoJudicial | null
  [FormField.ORGANO_DESTINO_ORGANO_JUDICIAL]: OrganoJudicial | null
  [FormField.ORGANO_DESTINO_ORDEN_JUDICIAL]: Orden | null
}

export const OrganoDestinoFormInitialvalues: OrganoDestinoFormValues = {
  [FormField.COMUNIDAD_AUTONOMA]: null,
  [FormField.PROVINCIA]: null,
  [FormField.ORGANO_DESTINO_PARTIDO_JUDICIAL]: null,
  [FormField.ORGANO_DESTINO_ORGANO_JUDICIAL]: null,
  [FormField.ORGANO_DESTINO_ORDEN_JUDICIAL]: null
}

export const OrganoDestinoFormValidations = (): any => {
  return Yup.object().shape({
    [FormField.COMUNIDAD_AUTONOMA]: Yup.object()
      .nullable()
      .required(t('form.validation.required.default')),
    [FormField.PROVINCIA]: Yup.object()
      .nullable()
      .required(t('form.validation.required.default')),
    [FormField.ORGANO_DESTINO_PARTIDO_JUDICIAL]: Yup.object()
      .nullable()
      .required(t('form.validation.required.default')),
    [FormField.ORGANO_DESTINO_ORGANO_JUDICIAL]: Yup.object()
      .nullable()
      .required(t('form.validation.required.default')),
    [FormField.ORGANO_DESTINO_ORDEN_JUDICIAL]: Yup.object()
      .nullable()
      .required(t('form.validation.required.default'))
  })
}
